import { get } from "lodash";

export const DEFAULT_DURATION_KEYS = ["journee", "semaine", "annee"];
export const PARTNER_TARIFF_KEY = "PARTNER";

export const listRateBaseKeys = (rates) => {
  const unique = [
    ...new Set(
      Object.keys(rates || {})
        .map((key) => key.split("|")[0])
        .filter(Boolean),
    ),
  ];
  const known = DEFAULT_DURATION_KEYS.filter((key) => unique.includes(key));
  const extra = unique.filter((key) => !DEFAULT_DURATION_KEYS.includes(key));
  return [...known, ...extra];
};

export const hasPartnerTariff = (rates) =>
  Object.keys(rates || {}).some((key) =>
    key.endsWith(`|${PARTNER_TARIFF_KEY}`),
  );

export const domainOfFactor = (value, factorKey, extras = {}) => {
  const buckets = get(value, ["factorDefs", factorKey, "buckets"]);
  if (buckets && buckets.length > 0) {
    return buckets.map((bucket) => ({
      key: bucket.label,
      label: bucket.label,
    }));
  }
  if (factorKey === "age" && extras.ageBrackets && extras.ageBrackets.length) {
    return extras.ageBrackets.map((bracket) => ({
      key: bracket.name,
      label: bracket.name,
    }));
  }
  if (factorKey === "regime" && extras.regimes && extras.regimes.length) {
    return extras.regimes.map((regime) => ({
      key: regime.code,
      label: regime.name || regime.code,
    }));
  }
  if (factorKey === "zone" && extras.zones && extras.zones.length) {
    return extras.zones.map((zone) => ({
      key: zone.name,
      label: zone.name,
    }));
  }
  if (factorKey === "duration") {
    const fromRates = listRateBaseKeys(get(value, "rates"));
    const keys = fromRates.length > 0 ? fromRates : DEFAULT_DURATION_KEYS;
    return keys.map((key) => ({ key, label: key }));
  }
  return [];
};
